if (!customElements.get('infinite-pagination')) {
    customElements.define(
      'infinite-pagination',
      class InfinitePagination extends HTMLElement {
        constructor() {
          super();
          this.abortController = new AbortController();
          this.isLoading = false;
          this.triggerType = this.dataset.trigger || 'manual';
          this.nextUrl = this.querySelector('.infinite-pagination-items-wrapper a')?.href;
          this.resultItemsSelector = this.querySelector('.infinite-pagination-items-wrapper #resultItemsSelector').textContent;
          this.targetAppendSelector = this.querySelector('.infinite-pagination-items-wrapper #targetAppendSelector').textContent;
          this.setupEventListeners();
        }
  
        setupEventListeners() {
          if (this.triggerType === 'manual') {
            this.querySelector('.infinite-pagination-items-wrapper a').addEventListener('click', this.onClickLoadMore.bind(this));
          } else {
            this.setupIntersectionObserver();
          }
        }
  
        setupIntersectionObserver() {
          const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
          };
  
          this.intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && this.nextUrl && !this.isLoading) {
                this.fetchPage();
              }
            });
          }, observerOptions);
  
          const loadMoreTrigger = this.querySelector('.infinite-pagination-items-wrapper a');
          if (loadMoreTrigger) {
            this.intersectionObserver.observe(loadMoreTrigger);
          }
        }
  
        onClickLoadMore(e) {
          e.preventDefault();
          this.fetchPage();
        }
  
        toggleLoadingState(isLoading = !this.isLoading) {
          this.isLoading = isLoading;
          this.toggleAttribute('loading', this.isLoading);
        }
  
        renderResults(resultsMarkup) {
          this.toggleLoadingState(false);
  
          let target = document.querySelectorAll(this.targetAppendSelector);
          if (target?.length > 1) {
            throw "Multiple targets found, please specify a single target";
          } else {
            target = target[0];
          }
          const items = resultsMarkup.querySelectorAll(this.resultItemsSelector);
          this.nextUrl = resultsMarkup.querySelector('.infinite-pagination-items-wrapper a')?.href;
          if(this.nextUrl) {
            this.querySelector('.infinite-pagination-items-wrapper a').href = this.nextUrl;
          }
          this.querySelector('.infinite-pagination-items-wrapper a').classList.toggle('hidden', !this.nextUrl);
          if (items.length && target) {
            items.forEach((item) => {
              target.appendChild(item);
            });
          }
        }
  
        fetchPage() {
          this.toggleLoadingState(true);
  
          fetch(this.nextUrl, {
            signal: this.abortController.signal,
          })
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                this.toggleLoadingState(false);
                throw error;
              }
  
              return response.text();
            })
            .then((text) => {
              const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
              this.renderResults(resultsMarkup);
            })
            .catch((error) => {
              if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
              }
              this.toggleLoadingState(false);
              throw error;
            });
        }
      }
    );
  }
  